<!--
 * @Description: NfTips 提示语展示框
 * @Author: lijinpeng
 * @Date: 2022-04-15 11:02:15
 * @LastEditors: lijinpeng
-->
<template>
  <div
    class="nf-tips"
    :class="{
      'is-active': isActive,
    }"
    ref="nfTips"
  >
    <template v-if="multiple">
      <div v-if="showArrow" class="nf-tips__font pointer">
        <div class="flexCon" v-if="isActive" @click="isActive = false">
          <span>收起</span>
          <i class="el-icon-arrow-up font_500" />
        </div>
        <div class="flexCon" v-else @click="isActive = true">
          <span>查看更多</span>
          <i class="el-icon-arrow-down font_500" />
        </div>
      </div>
      <div
        v-for="(item, index) of tips"
        :key="index"
        class="nf-tips-item"
        :class="{ 'margin-b-10': tips.length > 1 }"
      >
        <p class="nf-tips-item__title" :class="{ 'margin-b-5': tips.length > 1 }">
          <span v-if="tips.length > 1">{{ `${index + 1}.` }}</span>
          <span v-html="item.title"></span>
        </p>
        <el-table :data="item.tableData" border size="mini" v-if="item.type === 'table'">
          <el-table-column
            v-for="head of item.tableHeads"
            :key="head.prop"
            :prop="head.prop"
            :label="head.label"
            :min-width="head.width"
          >
            <template v-if="head.slotName" v-slot="scope">
              <!-- 追加插槽 -->
              <slot :scope="scope.row" :name="head.slotName" />
            </template>
          </el-table-column>
        </el-table>
        <template v-if="tips.slotName">
          <slot :name="tips.slotName" />
        </template>
      </div>
    </template>
    <div v-if="!multiple" class="nf-tips-item" v-html="tips" />
  </div>
</template>
<script>
export default {
  name: 'NfTips',
  props: {
    tips: {
      type: Array,
      default: () => [],
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    isActive: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      defaultHeight: 32,
      showArrow: false,
    };
  },
  watch: {
    isActive: {
      deep: true,
      handler() {
        this.heightChange();
      },
    },
  },
  methods: {
    heightChange() {
      this.$emit('heightChange');
    },
  },
  mounted() {
    const { offsetHeight } = this.$refs['nfTips'];
    if (this.$props.multiple && offsetHeight > this.defaultHeight) {
      this.showArrow = true;
      // this.isActive = false;
    }
  },
};
</script>
<style lang="scss" scoped>
.nf-tips {
  width: 100%;
  padding: 0 16px;
  margin: 0;
  box-sizing: border-box;
  border-radius: 4px;
  position: relative;
  background-color: #fff;
  overflow: hidden;
  opacity: 1;
  align-items: center;
  transition: opacity 0.2s;
  font-size: 13px;
  background-color: #fef0e6;
  color: #f36807;
  position: relative;
  height: 32px;
  line-height: 32px;

  &.is-active {
    height: auto;
    line-height: 14px;
    padding: 8px 16px;
  }

  &__font {
    position: absolute;
    top: 0;
    right: 20px;
    color: #666666;

    &:hover {
      color: #445ebf;
    }

    span,
    i {
      height: 32px;
      margin-left: 3px;
      line-height: 32px;
      font-size: 12px;
    }
  }

  &-item {
    &:last-child {
      margin-bottom: 0 !important;
    }
  }
}
</style>
